<template>
  <span v-if="hasPopLink" :id="instanceId" :name="instanceId">
    <span @click.stop.prevent="navigateToPop()">
      <i class="fa-fw fal fa-globe-americas fa-lg clickable" :class="isDarkMode ? 'has-text-black' : 'has-text-success'" title="redirect to pop"/>
    </span>
  </span>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const mapDealerState = createNamespacedHelpers('dealer').mapState

export default {
  name: 'CustomerPopComponent',
  mixins: [],
  props: {
    value: {
      type: Number,
      default: 0
    },
    isDarkMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      customerId: this.value,
      instanceId: this.$uuid.v4()
    }
  },
  components: {
  },
  computed: {
    ...mapDealerState(['currentDealer']),
    hasPopLink: function () {
        return this.customerId > 0
    }
  },
  methods: {
    navigateToPop: function () {
        const popLink = process.env.VUE_APP_ROOT_POP + 'capturenote/' + this.customerId + '/' + this.currentDealer.id
        window.open(popLink, "_blank");
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      if (newValue) {
        this.customerId = newValue 
      }
    }
  },
  mounted () {
  }
}

</script>

<style scoped>
  .content ul{
    list-style-type: none;
    margin-top: 0
  }

  .modal-card-head, .modal-card-foot{
    padding: 20px !important
  }

  .vauto-status-container {
    margin-top: 20px;
    padding: 0;
    margin-left: 0;
    margin-right: 0;
  }

  .vauto-container-display-only {
    display: inline-flex;
    flex-flow: row;
    align-items: center;
    margin-top:10px;
  }

  .modal-fullscreen .modal-card {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    position: fixed;
    z-index: 100000;
    max-height: 100% !important;
  }

  .modal-card-body {
    overflow:auto;
    height: calc(110vh - 350px);
  }

</style>
